import { SplitContentContentConfig } from "../splitContentTypes";
import { useTranslation } from "react-i18next";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { getContentFullUrl } from "@/lib/contentUtils";
import { ContentCrud } from "@/pages/content/ContentCrud";

interface Props {
  onClose: () => void;
  onAttached: (config: SplitContentContentConfig) => void;
}

export const SplitContentAttachContentDialog: React.FC<Props> = ({ onClose, onAttached }) => {
  const { t } = useTranslation();
  return (
    <Dialog open onOpenChange={onClose}>
      <DialogContent className="max-w-[90vw] h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>{t("splitContent.attachContent")}</DialogTitle>
          <DialogDescription>
            <ContentCrud
              selectConfig={{
                types: ["image", "video"],
                onSelect: ({ contentStorageName, contentType, layoutConfig }) => {
                  const conf: SplitContentContentConfig = {
                    type: "content",
                    src: getContentFullUrl(contentStorageName),
                    contentType,
                    layoutConfig,
                  };
                  onAttached(conf);
                  onClose();
                },
              }}
            />
          </DialogDescription>
        </DialogHeader>
      </DialogContent>
    </Dialog>
  );
};
